// extracted by mini-css-extract-plugin
export var avatar = "_s1-3";
export var avatarContainer = "_s1-2";
export var avatarSpacer = "_s1-5";
export var avatarSpacerContainer = "_s1-4";
export var avatarStackContainer = "_s1-1";
export var bubble = "_s1-0";
export var remainderBubble = "_s1-6";